import { DisputeTypes } from "@portal/types/entities/dispute";

export const mapDisputeTypesOptionPredicate = (types: DisputeTypes) => {
  return { label: types.name, value: types.id };
};
